import React from 'react';
import TippingConfusion from './TippingConfusion';
import HowMuchToTip from './HowMuchToTip';
import ShareYourTwoCents from './ShareYourTwoCents';
import TrendingOnTippingGuide from './TrendingOnTippingGuide';
import ServiceWorkers from './ServiceWorkers';
import WhatIsTippingGuide from './WhatIsTippingGuide';
import AllAboutTipping from './AllAboutTipping';
import JoinOurCommunity from './JoinOurCommunity';
import CategoriesProvider from './HowMuchToTip/CategoryProvider';

export default function Home(): React.JSX.Element {
  return (
    <>
      <TippingConfusion />

      <CategoriesProvider>
        <HowMuchToTip />
      </CategoriesProvider>

      <ShareYourTwoCents />
      <TrendingOnTippingGuide />
      <ServiceWorkers />
      <WhatIsTippingGuide />
      <AllAboutTipping />
      <JoinOurCommunity />
    </>
  );
}
